// source: batch.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var user_pb = require('./user_pb.js');
goog.object.extend(proto, user_pb);
var major_pb = require('./major_pb.js');
goog.object.extend(proto, major_pb);
goog.exportSymbol('proto.pbs.Batch', null, global);
goog.exportSymbol('proto.pbs.BatchSearchForm', null, global);
goog.exportSymbol('proto.pbs.Batches', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pbs.Batches = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pbs.Batches.repeatedFields_, null);
};
goog.inherits(proto.pbs.Batches, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pbs.Batches.displayName = 'proto.pbs.Batches';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pbs.BatchSearchForm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pbs.BatchSearchForm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pbs.BatchSearchForm.displayName = 'proto.pbs.BatchSearchForm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pbs.Batch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pbs.Batch.repeatedFields_, null);
};
goog.inherits(proto.pbs.Batch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pbs.Batch.displayName = 'proto.pbs.Batch';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pbs.Batches.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pbs.Batches.prototype.toObject = function(opt_includeInstance) {
  return proto.pbs.Batches.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pbs.Batches} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pbs.Batches.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.pbs.Batch.toObject, includeInstance),
    count: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pagesize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pbs.Batches}
 */
proto.pbs.Batches.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pbs.Batches;
  return proto.pbs.Batches.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pbs.Batches} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pbs.Batches}
 */
proto.pbs.Batches.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pbs.Batch;
      reader.readMessage(value,proto.pbs.Batch.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPagesize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pbs.Batches.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pbs.Batches.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pbs.Batches} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pbs.Batches.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pbs.Batch.serializeBinaryToWriter
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated Batch data = 1;
 * @return {!Array<!proto.pbs.Batch>}
 */
proto.pbs.Batches.prototype.getDataList = function() {
  return /** @type{!Array<!proto.pbs.Batch>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pbs.Batch, 1));
};


/**
 * @param {!Array<!proto.pbs.Batch>} value
 * @return {!proto.pbs.Batches} returns this
*/
proto.pbs.Batches.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pbs.Batch=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pbs.Batch}
 */
proto.pbs.Batches.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pbs.Batch, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pbs.Batches} returns this
 */
proto.pbs.Batches.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional int64 count = 2;
 * @return {number}
 */
proto.pbs.Batches.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.Batches} returns this
 */
proto.pbs.Batches.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 pageSize = 4;
 * @return {number}
 */
proto.pbs.Batches.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.Batches} returns this
 */
proto.pbs.Batches.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pbs.BatchSearchForm.prototype.toObject = function(opt_includeInstance) {
  return proto.pbs.BatchSearchForm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pbs.BatchSearchForm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pbs.BatchSearchForm.toObject = function(includeInstance, msg) {
  var f, obj = {
    keyword: jspb.Message.getFieldWithDefault(msg, 1, ""),
    start: jspb.Message.getFieldWithDefault(msg, 2, 0),
    end: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pagesize: jspb.Message.getFieldWithDefault(msg, 4, 0),
    page: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pbs.BatchSearchForm}
 */
proto.pbs.BatchSearchForm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pbs.BatchSearchForm;
  return proto.pbs.BatchSearchForm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pbs.BatchSearchForm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pbs.BatchSearchForm}
 */
proto.pbs.BatchSearchForm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnd(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPagesize(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pbs.BatchSearchForm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pbs.BatchSearchForm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pbs.BatchSearchForm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pbs.BatchSearchForm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string keyword = 1;
 * @return {string}
 */
proto.pbs.BatchSearchForm.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pbs.BatchSearchForm} returns this
 */
proto.pbs.BatchSearchForm.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 start = 2;
 * @return {number}
 */
proto.pbs.BatchSearchForm.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.BatchSearchForm} returns this
 */
proto.pbs.BatchSearchForm.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 end = 3;
 * @return {number}
 */
proto.pbs.BatchSearchForm.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.BatchSearchForm} returns this
 */
proto.pbs.BatchSearchForm.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 pageSize = 4;
 * @return {number}
 */
proto.pbs.BatchSearchForm.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.BatchSearchForm} returns this
 */
proto.pbs.BatchSearchForm.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 page = 5;
 * @return {number}
 */
proto.pbs.BatchSearchForm.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.BatchSearchForm} returns this
 */
proto.pbs.BatchSearchForm.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pbs.Batch.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pbs.Batch.prototype.toObject = function(opt_includeInstance) {
  return proto.pbs.Batch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pbs.Batch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pbs.Batch.toObject = function(includeInstance, msg) {
  var f, obj = {
    batchid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    batchname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    batchstart: jspb.Message.getFieldWithDefault(msg, 3, 0),
    batchdue: jspb.Message.getFieldWithDefault(msg, 4, 0),
    batchcreator: (f = msg.getBatchcreator()) && user_pb.User.toObject(includeInstance, f),
    batchmajorList: jspb.Message.toObjectList(msg.getBatchmajorList(),
    major_pb.Major.toObject, includeInstance),
    batchdeleteat: jspb.Message.getFieldWithDefault(msg, 18, 0),
    batchupdateat: jspb.Message.getFieldWithDefault(msg, 7, 0),
    batchcreateat: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pbs.Batch}
 */
proto.pbs.Batch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pbs.Batch;
  return proto.pbs.Batch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pbs.Batch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pbs.Batch}
 */
proto.pbs.Batch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBatchstart(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBatchdue(value);
      break;
    case 5:
      var value = new user_pb.User;
      reader.readMessage(value,user_pb.User.deserializeBinaryFromReader);
      msg.setBatchcreator(value);
      break;
    case 6:
      var value = new major_pb.Major;
      reader.readMessage(value,major_pb.Major.deserializeBinaryFromReader);
      msg.addBatchmajor(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBatchdeleteat(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBatchupdateat(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBatchcreateat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pbs.Batch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pbs.Batch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pbs.Batch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pbs.Batch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBatchid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBatchname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBatchstart();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getBatchdue();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getBatchcreator();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      user_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getBatchmajorList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      major_pb.Major.serializeBinaryToWriter
    );
  }
  f = message.getBatchdeleteat();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getBatchupdateat();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getBatchcreateat();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional string batchId = 1;
 * @return {string}
 */
proto.pbs.Batch.prototype.getBatchid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pbs.Batch} returns this
 */
proto.pbs.Batch.prototype.setBatchid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string batchName = 2;
 * @return {string}
 */
proto.pbs.Batch.prototype.getBatchname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pbs.Batch} returns this
 */
proto.pbs.Batch.prototype.setBatchname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 batchStart = 3;
 * @return {number}
 */
proto.pbs.Batch.prototype.getBatchstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.Batch} returns this
 */
proto.pbs.Batch.prototype.setBatchstart = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 batchDue = 4;
 * @return {number}
 */
proto.pbs.Batch.prototype.getBatchdue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.Batch} returns this
 */
proto.pbs.Batch.prototype.setBatchdue = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional User batchCreator = 5;
 * @return {?proto.pbs.User}
 */
proto.pbs.Batch.prototype.getBatchcreator = function() {
  return /** @type{?proto.pbs.User} */ (
    jspb.Message.getWrapperField(this, user_pb.User, 5));
};


/**
 * @param {?proto.pbs.User|undefined} value
 * @return {!proto.pbs.Batch} returns this
*/
proto.pbs.Batch.prototype.setBatchcreator = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pbs.Batch} returns this
 */
proto.pbs.Batch.prototype.clearBatchcreator = function() {
  return this.setBatchcreator(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pbs.Batch.prototype.hasBatchcreator = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated Major batchMajor = 6;
 * @return {!Array<!proto.pbs.Major>}
 */
proto.pbs.Batch.prototype.getBatchmajorList = function() {
  return /** @type{!Array<!proto.pbs.Major>} */ (
    jspb.Message.getRepeatedWrapperField(this, major_pb.Major, 6));
};


/**
 * @param {!Array<!proto.pbs.Major>} value
 * @return {!proto.pbs.Batch} returns this
*/
proto.pbs.Batch.prototype.setBatchmajorList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.pbs.Major=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pbs.Major}
 */
proto.pbs.Batch.prototype.addBatchmajor = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.pbs.Major, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pbs.Batch} returns this
 */
proto.pbs.Batch.prototype.clearBatchmajorList = function() {
  return this.setBatchmajorList([]);
};


/**
 * optional int64 batchDeleteAt = 18;
 * @return {number}
 */
proto.pbs.Batch.prototype.getBatchdeleteat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.Batch} returns this
 */
proto.pbs.Batch.prototype.setBatchdeleteat = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 batchUpdateAt = 7;
 * @return {number}
 */
proto.pbs.Batch.prototype.getBatchupdateat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.Batch} returns this
 */
proto.pbs.Batch.prototype.setBatchupdateat = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 batchCreateAt = 8;
 * @return {number}
 */
proto.pbs.Batch.prototype.getBatchcreateat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pbs.Batch} returns this
 */
proto.pbs.Batch.prototype.setBatchcreateat = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


goog.object.extend(exports, proto.pbs);
